module.exports = __webpack_public_path__ + "static/media/texture-season-1.17be7e0e.jpg";